import { api } from './api';

export interface WebhookDto {
  id: number;
  url: string;
  events: string[];
  active: boolean;
  beschreibung: string | null;
  failCount: number;
  disabledAt: string | null;
  createdAt: string;
  secret: string;
}

export interface DeliveryDto {
  id: number;
  event: string;
  status: 'pending' | 'success' | 'failed';
  attempt: number;
  responseStatus: number | null;
  responseBody: string | null;
  nextAttemptAt: string | null;
  deliveredAt: string | null;
  createdAt: string;
  /** Jeder Versuch einzeln — damit sichtbar ist, DASS wiederholt wurde. */
  verlauf: Array<{ versuch: number; at: string; responseStatus: number | null; antwort: string | null; ok: boolean }>;
}

export interface Bedingung {
  feld: string;
  op: string;
  wert?: string | number | null;
}

export interface RegelDto {
  id: number;
  name: string;
  subject: 'customer' | 'vorgang' | 'report';
  active: boolean;
  conditions: Bedingung[];
  webhookId: number;
  createdAt: string;
}

export interface KatalogDto {
  events: Array<{ name: string; text: string }>;
  felder: Record<string, ReadonlyArray<{ feld: string; text: string; typ: string }>>;
  operatoren: Array<{ name: string; text: string }>;
}

export const getKatalog = () => api.get<KatalogDto>('/api/webhooks/katalog');

export const listWebhooks = () => api.get<WebhookDto[]>('/api/webhooks');
export const createWebhook = (url: string, events: string[], beschreibung?: string) =>
  api.post<WebhookDto>('/api/webhooks', { url, events, beschreibung });
export const patchWebhook = (id: number, daten: Partial<{ url: string; events: string[]; active: boolean; beschreibung: string }>) =>
  api.patch<WebhookDto>(`/api/webhooks/${id}`, daten);
export const deleteWebhook = (id: number) => api.delete<{ ok: boolean }>(`/api/webhooks/${id}`);
export const testWebhook = (id: number) => api.post<{ ok: boolean; hinweis: string }>(`/api/webhooks/${id}/test`, {});
export const listDeliveries = (id: number) => api.get<DeliveryDto[]>(`/api/webhooks/${id}/deliveries`);
export const retryDelivery = (id: number) => api.post<DeliveryDto>(`/api/webhooks/deliveries/${id}/retry`, {});

export const listRegeln = () => api.get<RegelDto[]>('/api/automation-rules');
export const createRegel = (r: Omit<RegelDto, 'id' | 'createdAt' | 'active'> & { active?: boolean }) =>
  api.post<{ id: number }>('/api/automation-rules', r);
export const deleteRegel = (id: number) => api.delete<{ ok: boolean }>(`/api/automation-rules/${id}`);
